import { View } from 'react-native';

import { RadioGroup, XStack } from '@fhs/ui';

import { BORDER_RADIUS } from './constants';
import { listStyles } from './shared-styles';

type ListItemRadioWithChildrenProps = {
  value: string;
  label: string;
  disabled?: boolean;
  isFirstItem?: boolean;
  isLastItem?: boolean;
  indicatorSize?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
};

export function ListItemRadioWithChildren({
  value,
  label,
  disabled,
  isFirstItem,
  isLastItem,
  indicatorSize = 'sm',
  children,
}: ListItemRadioWithChildrenProps) {
  const borderStyles = {
    borderTopLeftRadius: isFirstItem ? BORDER_RADIUS : 0,
    borderTopRightRadius: isFirstItem ? BORDER_RADIUS : 0,
    borderBottomLeftRadius: isLastItem ? BORDER_RADIUS : 0,
    borderBottomRightRadius: isLastItem ? BORDER_RADIUS : 0,
  };

  return (
    <RadioGroup.Item value={value} label={label} disabled={disabled}>
      <RadioGroup.Pressable
        style={[
          listStyles.item, // same container style ListItemRadio uses
          isLastItem && listStyles.lastItem,
        ]}
        hoveredStyle={listStyles.itemHover}
        {...borderStyles}
      >
        {/* Your custom content goes here */}
        <View style={listStyles.titleTextContainer}>{children}</View>

        {/* Keep the radio UI on the right */}
        <XStack style={listStyles.indicatorWithTextWrapper}>
          <RadioGroup.CircleIndicator size={indicatorSize === 'lg' ? 'md' : indicatorSize} />
        </XStack>
      </RadioGroup.Pressable>
    </RadioGroup.Item>
  );
}
